import * as yup from 'yup';

export const servicioInternetActivacionSchema = yup.object({
  ///* servicio instalacion -----------------
  ipv_4_actual: yup.string().required('El ipv_4_actual es requerido'),
  pppoe: yup.string().required('El PPOE es Requerido'),
  pppassword: yup.string().required('El PPPASSWORD es Requerido'),

  // -- solicitud cambio nap & puerto
  nap: yup.string().required('El NAP es Requerido'),
  puerto: yup
    .number()
    .typeError('El puerto es Requerido')
    .required('El puerto es Requerido')
    .min(1, 'Puerto inválido'),
  distancia: yup.string().required('La distancia es requerida'),
  router_ac: yup.string().required('El router AC es Requerido'),
  estado_activacion: yup
    .string()
    .required('El estado de activación es requerido'),
  user: yup
    .number()
    .typeError('El usuario es Requerido')
    .required('El usuario es Requerido'),
  observacion_activacion: yup.string().optional(),
  user_activacion: yup
    .number()
    .typeError('El usuario de activación es Requerido')
    .optional(),

  // data q viene desde agenda
  // numero_contrato: yup.string().optional(),
  // estado_servicio: yup.string().required('El estado del servicio es requerido'),
  // velocidad: yup.string().required('La velocidad es requerida'),
  coordenadas: yup.string().required('Las coordenadas son requeridas'),
  direccion: yup.string().required('La dirección es requerida'),
  // opcion_value: yup.string().required('El valor de la opción es requerido'),

  ///* fk en ServicioInternet -----------------
  plan: yup
    .number()
    .typeError('El plan es Requerido')
    .required('El plan es Requerido'),
  olt: yup.string().required('El OLT es requerido'),
  nodo: yup.string().required('El nodo es requerido'),

  ///* OT : UPD -----------------
  hora_inicio: yup.string().required('La hora de inicio es requerida'),
  hora_fin: yup.string().required('La hora de fin es requerida'),
  isRequiredHoraFin: yup.boolean().optional(),
  // hora_fin: yup
  //   .string()
  //   .optional()
  //   .nullable()
  //   .when('isRequiredHoraFin', {
  //     is: true,
  //     then: schema => schema.required('La hora de fin es requerida'),
  //   }),
});

export const servicioInternetActivacionHoraInicioSchema = yup.object({
  hora_inicio: yup.string().required('La hora de inicio es requerida'),
});
